module.exports = __webpack_public_path__ + "media/images/gallery/oc_tab_on-28a68d4b27f462ef132192e9ef957eb1.jpg";